import { createAsyncThunk } from "@reduxjs/toolkit";
import { getEvidenceViewAPI } from "../../apiConfig/apiCall";

export const getEvidenceViewList = createAsyncThunk('getEvidenceViewList', async (FILTER_DATE) => {
    const response = await getEvidenceViewAPI(FILTER_DATE);
    return response.data;
});